pollsPresenter.controller('pollsPresenterCtrl', [
    '$rootScope',
    '$scope',
    'attendeeService',
    'logService',
    'pollingService',
    'localizationService',
    function ($rootScope, $scope, attendeeService, logService, pollingService, localizationService) {
        var self = this;
        const logger = logService.createLoggerWithSource('pollsPresenterCtrl');

        // Event listener functions
        self.onVotingStarted = onVotingStarted;
        self.onVotingStopped = onVotingStopped;
        self.onVotesUpdate = onVotesUpdate;
        self.onVotesPrivacyUpdate = onVotesPrivacyUpdate;

        // Functions
        self.activePoll = activePoll;
        self.getVotePercentage = getVotePercentage;
        self.selectPresenterViewOption = selectPresenterViewOption;
        self.onVotesPrivacyClick = onVotesPrivacyClick;
        self.submitVote = submitVote;
        self.closeVote = closeVote;
        self.isVotePercentageVisible = isVotePercentageVisible;

        self.getSubmitVoteTooltip = getSubmitVoteTooltip;

        // Variables
        // self.answerIndex;
        self.attendantLoginId = attendeeService.getAttendantLoginId();
        self.canVote = true;

        self.presenterViewSettings = {
            sharePercentage: false,
            shareCount: false
        };

        self.presenterViewOptions = [
            {
                id: 'share-none',
                text: localizationService.translate('POLLS.SHARE_OPTIONS.DONT_SHARE_RESULTS_WITH_ATTENDEES')
            },
            {
                id: 'share-percent',
                text: localizationService.translate('POLLS.SHARE_OPTIONS.SHARE_VOTE_PERCENTAGE_WITH_ATTENDEES')
            },
            {
                id: 'share-percent-count',
                text: localizationService.translate(
                    'POLLS.SHARE_OPTIONS.SHARE_VOTE_PERCENTAGE_AND_TOTALS_WITH_ATTENDEES'
                )
            }
        ];

        self.curPresenterViewOption = getPresenterViewOptionById('share-none');

        // Event listeners
        $scope.$on('voting-started', self.onVotingStarted);
        $scope.$on('voting-stopped', self.onVotingStopped);
        $scope.$on('votes-update', self.onVotesUpdate);
        $scope.$on('votes-privacy-update', self.onVotesPrivacyUpdate);

        ////////////////////////

        function activePoll() {
            return pollingService.getActivePoll();
        }

        function onVotingStarted() {
            self.canVote = true;
            self.answerIndex = undefined;
            digest();
        }

        function onVotingStopped() {
            digest();
        }

        function getVotePercentage(votes) {
            var percentage = Math.round((votes / self.activePoll().totalVotes) * 100);

            if (!percentage) {
                percentage = 0;
            }

            return percentage + '%';
        }

        function onVotesPrivacyClick(newOption) {
            selectPresenterViewOption(newOption);
            pollingService.setVotingPrivacy(newOption.id);
        }

        function selectPresenterViewOption(newOption) {
            logger.log('New Presenter View Option selected:', newOption);

            var sharePercentage = false;
            var shareCount = false;

            switch (newOption.id) {
                case 'share-percent':
                    sharePercentage = true;
                    break;
                case 'share-percent-count':
                    sharePercentage = true;
                    shareCount = true;
                    break;
                case 'share-none':
                    break;
            }

            self.presenterViewSettings.sharePercentage = sharePercentage;
            self.presenterViewSettings.shareCount = shareCount;
            self.curPresenterViewOption = getPresenterViewOptionById(newOption.id);
        }

        function onVotesPrivacyUpdate(event, optionId) {
            selectPresenterViewOption(getPresenterViewOptionById(optionId));
        }

        //Helper Function
        function getPresenterViewOptionById(id) {
            for (i = 0; i < self.presenterViewOptions.length; i++) {
                if (self.presenterViewOptions[i].id === id) {
                    return self.presenterViewOptions[i];
                }
            }

            return false;
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function submitVote() {
            if (self.canVote && self.answerIndex !== undefined) {
                // Send vote to server
                pollingService.vote(self.attendantLoginId, self.answerIndex);

                // Disable local voting buttons
                self.canVote = false;
            }
        }

        function closeVote() {
            pollingService.stopVoting(self.attendantLoginId);
        }

        function onVotesUpdate() {
            digest();
        }

        function isVotePercentageVisible() {
            if (attendeeService.getIsPresenter()) {
                return true;
            } else {
                if (self.presenterViewSettings.sharePercentage || self.presenterViewSettings.shareCount) {
                    return true;
                }
            }

            return false;
        }

        function getSubmitVoteTooltip() {
            return self.canVote
                ? self.answerIndex === undefined
                    ? localizationService.translate('POLLS.YOU_MUST_SELECT_AN_ANSWER')
                    : localizationService.translate('POLLS.SUBMIT_YOUR_VOTE')
                : localizationService.translate('POLLS.YOU_CANNOT_VOTE_MORE_THAN_ONCE');
        }
    }
]);
